module.exports = function() {
  return new Worker(__webpack_public_path__ + "b6e13996b49168c38e0d.worker.js");
};